import Vue from 'vue'
//引入vuex
import Vuex from 'vuex'
import getters from './getters'
//vuex持久化
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
export default new Vuex.Store({
  getters,
  modules: {
    
  },
  state: {
    circles:'', //多届次 ","隔开
    tabMain:'',//首页教师功能标签页选中值
    menuId:'', //打开菜单的ID
    menuIndex:{}, //个人办公菜单
    menuApply:{}, //应用中心菜单
    businessId:'',
    selectedTreeNode:{},//选中的unittree节点
    selectedBj:{},//选中的班级
    menuId:'',//菜单id
    menus:[],//菜单列表
    syllabusId:'',
    assemblys:[],
    attendences:{},
    globalType:'',
    menuObject:{}, //菜单管理
    roleId:'',
  },
  mutations: {
    setCircles(state,circles) {
      state.circles = circles;
    },
    setTabMain(state,tabMain) {
      state.tabMain = tabMain;
    },
    setMenuId(state,menuId) {
      state.menuId = menuId;
    },
    setMenuIndex(state,menuIndex) {
      state.menuIndex = menuIndex;
    },
    setMenuApply(state,menuApply) {
      state.menuApply = menuApply;
    },
    setBusinessId(state,businessId){
      state.businessId = businessId;
    },
    setSelectedTreeNode(state,selectedTreeNode) {
      state.selectedTreeNode = selectedTreeNode;
    },
    setSelectedBj(state,selectedBj){
      state.selectedBj = selectedBj;
    },
    setMenuId(state,menuId){
      state.menuId = menuId;
    },
    setMenus(state,menus){
      state.menus = menus;
    },
    setSyllabusId(state,syllabusId){
      state.syllabusId = syllabusId;
    },
    setAssemblys(state,assemblys){
      state.assemblys=assemblys
    },
    setAttendence(state,attendences){
      state.attendences = attendences
    },
    setGlobalType(state,globalType){
      state.globalType = globalType
    },
    setMenuObject(state,menuObject) {
      state.menuObject = menuObject;
    },
    setRoleId(state,roleId){
      state.roleId = roleId;
    },
  },
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js